/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ConsentFormsDto,
  ErrorResponse,
  LegalDocumentsDto,
  SupportPortalDto,
} from '../models/index';
import {
    ConsentFormsDtoFromJSON,
    ConsentFormsDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    LegalDocumentsDtoFromJSON,
    LegalDocumentsDtoToJSON,
    SupportPortalDtoFromJSON,
    SupportPortalDtoToJSON,
} from '../models/index';

/**
 * 
 */
export class LegalApi extends runtime.BaseAPI {

    /**
     * Returns signed URLs to all consent documents stored in Cloud Storage for the authenticated practice
     * Get consent forms for practice
     */
    async getConsentFormsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConsentFormsDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/legal/consent-forms`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConsentFormsDtoFromJSON(jsonValue));
    }

    /**
     * Returns signed URLs to all consent documents stored in Cloud Storage for the authenticated practice
     * Get consent forms for practice
     */
    async getConsentForms(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConsentFormsDto> {
        const response = await this.getConsentFormsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns URLs to the privacy policy, terms and conditions, and disclaimer documents
     * Get legal documents URLs
     */
    async getLegalDocumentsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LegalDocumentsDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/legal/documents`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LegalDocumentsDtoFromJSON(jsonValue));
    }

    /**
     * Returns URLs to the privacy policy, terms and conditions, and disclaimer documents
     * Get legal documents URLs
     */
    async getLegalDocuments(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LegalDocumentsDto> {
        const response = await this.getLegalDocumentsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns the URL to the customer support portal
     * Get support portal URL
     */
    async getSupportPortalRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupportPortalDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/legal/support-portal`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportPortalDtoFromJSON(jsonValue));
    }

    /**
     * Returns the URL to the customer support portal
     * Get support portal URL
     */
    async getSupportPortal(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupportPortalDto> {
        const response = await this.getSupportPortalRaw(initOverrides);
        return await response.value();
    }

}
